<gds-full-screen-modal opened (modalClose)="backToViewEntitlement()">
  <!--Enlarge Qr code model popup-->
  <div slot="components">
    <div class="container modal-content">
      <div class="card">
        <div class="center-align">
          <!--Qr code image-->
          <div class="content-center">
            <div class="qrcodeImage">
              <qrcode
                #parent
                [qrdata]="mediaID"
                [allowEmptyString]="true"
                [ariaLabel]=""
                [cssClass]="'center'"
                [colorDark]="'#000000ff'"
                [colorLight]="'#ffffffff'"
                [elementType]="'canvas'"
                [errorCorrectionLevel]="'M'"
                [margin]="4"
                [scale]="1"
                [title]=""
                [width]="250"
              ></qrcode>
            </div>
          </div>

          <!--Media ID and full name-->
          <div class="name-center">
            <gds-heading
              class="B1-W3"
              classes="heading-7"
              [data]="{
                heading: mediaID,
              }"
            ></gds-heading>
            <gds-spacer classes="spacer-50"></gds-spacer>
            <gds-heading
              class="A2-W5"
              classes="heading-5"
              [data]="{
                heading: fullName,
              }"
            ></gds-heading>
          </div>
          <gds-spacer classes="spacer-30"></gds-spacer>

          <!--QR code information messages-->
          <div class="name-center">
            <gds-heading
              class="B1-W3"
              classes="heading-7"
              [data]="{
                heading: pageLabels?.['scanQR.info'],
              }"
            ></gds-heading>
            <gds-spacer classes="spacer-30"></gds-spacer>

            <gds-heading
              class="B1-W3"
              classes="heading-7"
              [data]="{
                heading: pageLabels?.['enalrgeQR.info'],
              }"
            ></gds-heading>
          </div>
        </div>
      </div>
    </div>
  </div>
</gds-full-screen-modal>
